// extracted by mini-css-extract-plugin
module.exports = {"root":"MediaFeedNavigation_root__FxNqI","link":"MediaFeedNavigation_link__z0_8w","text":"MediaFeedNavigation_text__ufIOV","icon":"MediaFeedNavigation_icon__Yj8dU"};